"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _uuid = require("uuid");

var _cartDrawer = require("../global/cart-drawer");

var _cartDrawer2 = _interopRequireDefault(_cartDrawer);

var _topBarFunctions = require("../global/top-bar-functions");

var _topBarFunctions2 = _interopRequireDefault(_topBarFunctions);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var scrollTop = 0;

var Cart = function () {
  function Cart(data) {
    (0, _classCallCheck3.default)(this, Cart);

    this.frameId = data.frameId;
    this.lensId = data.lensId;
    this.lensProps = data.lensProps;
    this.frameProps = data.frameProps;
    this.customer = data.customer;
  }

  (0, _createClass3.default)(Cart, [{
    key: "add",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
        var _this = this;

        var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios2.default.post("/cart/add.js", { quantity: 1, id: id, properties: properties }, { headers: { "X-Requested-With": "XMLHttpRequest" } }).then(function (result) {
                  var data = result.data;
                  var product_type = data.product_type,
                      key = data.key;

                  if (product_type.toLowerCase() === "lens") {
                    _this.frameProps["_lensLineId"] = key;
                  }
                  return result;
                }).catch(function (error) {
                  return window.alert(error);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function add(_x) {
        return _ref.apply(this, arguments);
      }

      return add;
    }()
  }, {
    key: "mapSissData",
    value: function mapSissData(prescription, lens, prxID, prxPresID, prxProfileID, prxEmailAddress) {
      var handle = lens.title.split(":")[0].replace(/\s+/g, "_").toLowerCase();
      var lensName = this.frameProps["lens type"].split(":")[0].trim();
      var frameName = this.lensProps._frame;
      var object = {
        data: {
          prescription: {
            id: prxID || "",
            prescription_id: prxPresID || "",
            profile_id: prxProfileID,
            email_address: prxEmailAddress,
            prescription_purpose: prescription.type,
            prescription_vision: handle,
            sph_od: prescription.right.sph || "0",
            cyl_od: prescription.right.cyl || "0.00",
            axis_od: prescription.right.axis || "0",
            add_od: prescription.right.add || "0",
            ipd_od: prescription.right.ipd || "30",
            ph_od: prescription.right.ph || "0",
            va_od: "20",
            sph_os: prescription.left.sph || "0",
            cyl_os: prescription.left.cyl || "0.00",
            axis_os: prescription.left.axis || "0",
            add_os: prescription.left.add || "0",
            ipd_os: prescription.left.ipd || "30",
            ph_os: prescription.left.ph || "0",
            va_os: "20",
            lens_name: lensName,
            frame_name: frameName,
            store: "Sunnies Studio Online"
          }
        }
      };
      return object;
    }
  }, {
    key: "postPrescription",
    value: function postPrescription(activePrescription, finalLens) {
      var _this2 = this;

      var url = "https://www.sunniessystems.com/api/3.0/324566/new-prescription/?client_id=95jgnvudiht03075kdhfrw256789dhif";
      var apiKey = "052398FSOWRI2UR7FHJKG789403JHFSA";
      var headers = {
        "oassis-api-key": apiKey,
        "Content-Type": "application/json"
      };

      // set guest data in local storage
      var guestData = void 0;
      var guestDataId = (0, _uuid.v4)();
      var guestDataEmail = "guest" + guestDataId.replaceAll("-", "") + "@ssguest.com";

      if (localStorage.getItem("guestData") === null && this.customer !== null) {
        guestData = {
          user_id: guestDataId,
          email_address: guestDataEmail
        };
        localStorage.setItem("guestData", JSON.stringify(guestData));
      } else {
        guestData = JSON.parse(localStorage.getItem("guestData"));
      }

      var ssisProfileId = this.customer.id || guestData.user_id;
      var ssisEmailAddress = this.customer.email || guestData.email_address;

      var data = this.mapSissData(activePrescription, finalLens, "", "", ssisProfileId, ssisEmailAddress);

      // POST to endpoint, await ID, update and continue
      (0, _axios2.default)({
        url: url,
        method: "post",
        headers: headers,
        data: data
      }).then(function (result) {
        _this2.postPrescriptionB(activePrescription, finalLens, result.data.id, result.data.prescription_id, result.data.profile_id, result.data.email_address);
        return true;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: "postPrescriptionB",
    value: function postPrescriptionB(activePrescription, finalLens, id, prescription_id, profile_id, email_address) {
      var _this3 = this;

      var url = "https://www.sunniesspecs.com/api/3.0/324566/new-prescription/?client_id=95jgnvudiht03075kdhfrw256789dhif";
      var apiKey = "052398FSOWRI2UR7FHJKG789403JHFSA";
      var headers = {
        "oassis-api-key": apiKey,
        "Content-Type": "application/json"
      };
      var data = this.mapSissData(activePrescription, finalLens, id, prescription_id, profile_id, email_address);

      // POST to endpoint, await ID, update and continue
      (0, _axios2.default)({
        url: url,
        method: "post",
        headers: headers,
        data: data
      }).then(function (result) {
        _this3.frameProps["_prescription_id"] = result.data.prescription_id;
        _this3.lensProps["prescription id"] = result.data.prescription_id;
        _this3.addLens();
        return true;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: "addLens",
    value: function addLens() {
      var _this4 = this;

      this.add(this.lensId, this.lensProps).then(function () {
        _this4.addFrame();
        return true;
      }).catch(function (error) {
        return window.alert(error);
      });
    }
  }, {
    key: "addFrame",
    value: function addFrame() {
      this.add(this.frameId, this.frameProps).then(function () {
        (0, _cartDrawer2.default)(true);
        document.querySelector(".cart-drawer").classList.add("expanded");
        (0, _topBarFunctions2.default)();
        (0, _jquery2.default)("html").addClass("no-scroll");

        scrollTop = (0, _jquery2.default)(window).scrollTop();
        (0, _jquery2.default)("body").attr("data-top", (0, _jquery2.default)(window).scrollTop()).css("top", -scrollTop);
        return true;
      }).catch(function (error) {
        return window.alert(error);
      });
    }
  }]);
  return Cart;
}();

exports.default = Cart;